import { cn } from "~/lib/utils";

/** Product / Features vertical tab: filled primary when selected. */
export function marketingVerticalTabClass(selected: boolean): string {
  return cn(
    "flex w-full items-center gap-3 rounded-md px-4 py-3 text-left text-sm font-medium transition-all",
    selected
      ? "bg-[#4f81bd] text-white"
      : "text-slate-500 hover:bg-slate-100 hover:text-slate-900",
  );
}

/** Product / Features card: compact bordered tile with icon slot. */
export function marketingCardClass(className?: string): string {
  return cn("rounded-md border border-slate-200 bg-white p-5", className);
}

export function marketingCardIconClass(): string {
  return "flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-[#4f81bd]/10 text-[#4f81bd]";
}
